export default {
  addRow: {
    id: 'questionBuilder.addRow',
    description: 'Message for adding a goal',
    defaultMessage: 'New Goal'
  },
  prompt: {
    id: 'questionBuilder.prompt',
    description: 'The default message prompt for selecting your goal.',
    defaultMessage: 'What is your goal?'
  },
  validationRequired: {
    id: 'questionBuilder.validation.required',
    description: 'The default required validation message',
    defaultMessage: 'Please provide an answer.'
  },
  validationBetween: {
    id: 'questionBuilder.validation.between',
    description: 'The min/max required validation message',
    defaultMessage: 'Amount must be between {min} and {max}'
  },
  validationMinimum: {
    id: 'questionBuilder.validation.minimum',
    description: 'The minimum required validation message',
    defaultMessage: 'Amount must be more than {min}'
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/i18n/MessageDefinitions.js
 **/